export class GruppeStandortTier {
    gst_id: number;
    gs_id: number;
    gt_id: number;
    abgangsgewicht: number;
    einstallgewicht: number;
}
